<template>
  <b-tabs content-class="mt-3" :value="tabIndex">
    <b-tab      
      :title="$t('allLicenses')"
      :title-link-class="tabClass"
      @click="handleAssetTabClick"
    >
      <router-view />
    </b-tab>
    <b-tab
      :title="$t('manageLicenses')"
      :title-link-class="tabClass"
      @click="handleManageLicensesTabClick"
    >
      <router-view />
    </b-tab>
  </b-tabs>
</template>

<script>
  import LicenseLists from './LicenseLists'
  import AllAssets from './AllAssets'

  export default {
    name: 'Home',
    components: {
      'license-lists': LicenseLists,
      'all-assets': AllAssets
    },
    computed: {
      tabIndex () {
        return this.$route.path.includes('/login') || this.$route.path === '/' ? 0 : 1
      },
      isLoginPath () {
        return this.$route.path.includes('/login')
      },
      isEmailPath () {
        return this.$route.path.includes('/email')
      },
      tabClass () {
        return (this.isLoginPath || this.isEmailPath) ? 'hidden-tab' : ''
      }
    },
    methods: {
      handleAssetTabClick () {
        this.$store.commit('setPreviousPath', this.$route.path)
        if (!this.isLoginPath) {
          this.$router.replace('/')
        }
      },
      handleManageLicensesTabClick () {
        const path = this.$store.getters.previousPath
        this.$router.replace(!path || path === '/login' || path === '/' ? '/manage-licenses' : path)
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .btn {
    border-radius: 50px;
  }
  .hidden-tab {
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/TabbedHomeView.vue